import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIResponseDiscipline,
  useResponseDisciplinesTableContext,
} from '../../../../ResponseDisciplinesTableContext'
import { useSoftRemoveRfiResponseDisciplineMutation } from 'schema'

export function useRemoveOptions(): RemoveRowActionOptions<RFIResponseDiscipline> {
  const { refetch } = useResponseDisciplinesTableContext()
  const [removeResponseDiscipline] = useSoftRemoveRfiResponseDisciplineMutation(
    {
      ...DefaultMutationHookOptions,
      onCompleted: ({
        softRemoveRFIResponseDiscipline: {
          responseDiscipline: { name },
        },
      }) => simpleRemoveNotification(name),
    }
  )
  return {
    permission: Permission.RemoveRestoreRFIResponseDiscipline,
    disabled: ({ requestsForInformation }) =>
      !!requestsForInformation.length
        ? {
            message:
              "Response Disciplines cannot be deleted if they are associated with one or more RFI's",
          }
        : false,
    onRemove: async ({ id }) => {
      await removeResponseDiscipline({ variables: { id } })
      refetch()
    },
  }
}
